var _path, _path2, _path3, _path4, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse0, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoHeader(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2801,
    height: 1000,
    viewBox: "0 0 2801 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M480.25 14.2891C492.471 7.23319 507.529 7.23319 519.75 14.2891L910.763 240.041C922.984 247.097 930.513 260.137 930.513 274.249V725.751C930.513 739.863 922.984 752.903 910.763 759.959L519.75 985.711C507.529 992.767 492.471 992.767 480.25 985.711L89.2373 759.959C77.016 752.903 69.4873 739.863 69.4873 725.751V274.249C69.4873 260.137 77.016 247.097 89.2373 240.041L480.25 14.2891Z",
    fill: "url(#paint0_linear_286_15)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M480.25 14.2891C492.471 7.23319 507.529 7.23319 519.75 14.2891L910.763 240.041C922.984 247.097 930.513 260.137 930.513 274.249V725.751C930.513 739.863 922.984 752.903 910.763 759.959L519.75 985.711C507.529 992.767 492.471 992.767 480.25 985.711L89.2373 759.959C77.016 752.903 69.4873 739.863 69.4873 725.751V274.249C69.4873 260.137 77.016 247.097 89.2373 240.041L480.25 14.2891Z",
    fill: "url(#paint1_radial_286_15)",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M480.25 14.2891C492.471 7.23319 507.529 7.23319 519.75 14.2891L910.763 240.041C922.984 247.097 930.513 260.137 930.513 274.249V725.751C930.513 739.863 922.984 752.903 910.763 759.959L519.75 985.711C507.529 992.767 492.471 992.767 480.25 985.711L89.2373 759.959C77.016 752.903 69.4873 739.863 69.4873 725.751V274.249C69.4873 260.137 77.016 247.097 89.2373 240.041L480.25 14.2891Z",
    fill: "url(#paint2_radial_286_15)",
    fillOpacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M480.25 14.2891C492.471 7.23319 507.529 7.23319 519.75 14.2891L910.763 240.041C922.984 247.097 930.513 260.137 930.513 274.249V725.751C930.513 739.863 922.984 752.903 910.763 759.959L519.75 985.711C507.529 992.767 492.471 992.767 480.25 985.711L89.2373 759.959C77.016 752.903 69.4873 739.863 69.4873 725.751V274.249C69.4873 260.137 77.016 247.097 89.2373 240.041L480.25 14.2891Z",
    stroke: "url(#paint3_linear_286_15)",
    strokeWidth: 5
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 494.321,
    cy: 254.881,
    rx: 65.7468,
    ry: 40.5844,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 493.509,
    cy: 262.185,
    rx: 64.9351,
    ry: 33.2792,
    fill: "url(#paint4_linear_286_15)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 275.161,
    cy: 254.881,
    rx: 65.7468,
    ry: 40.5844,
    fill: "black"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 274.349,
    cy: 262.185,
    rx: 64.9351,
    ry: 33.2792,
    fill: "url(#paint5_linear_286_15)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 723.208,
    cy: 254.881,
    rx: 65.7468,
    ry: 40.5844,
    fill: "black"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 722.396,
    cy: 262.185,
    rx: 64.9351,
    ry: 33.2792,
    fill: "url(#paint6_linear_286_15)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 494.321,
    cy: 386.366,
    rx: 65.7468,
    ry: 40.5844,
    fill: "black"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 493.509,
    cy: 393.67,
    rx: 64.9351,
    ry: 33.2792,
    fill: "url(#paint7_linear_286_15)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 494.321,
    cy: 126.639,
    rx: 65.7468,
    ry: 40.5844,
    fill: "black"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 493.509,
    cy: 133.943,
    rx: 64.9351,
    ry: 33.2792,
    fill: "url(#paint8_linear_286_15)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M863.505 335.417C863.79 346.423 864.017 357.427 864.173 368.434L864.236 373.291C864.293 377.806 864.366 382.322 864.469 386.838L864.582 391.354C864.741 397.157 864.828 402.957 864.866 408.764V408.77C864.886 410.435 864.921 412.1 864.971 413.765L865.025 415.43C865.324 424.141 865.459 428.305 864.913 431.045C864.404 433.599 863.317 434.861 860.76 437.719C857.107 440.187 853.515 442.08 849.462 443.891L849.407 443.915L849.355 443.946C847.867 444.838 846.378 445.73 844.844 446.649C843.591 447.344 842.337 448.039 841.046 448.755L841.043 448.757C839.59 449.568 838.137 450.38 836.64 451.216C835.12 452.059 833.6 452.902 832.034 453.771L832.031 453.772C820.998 459.95 810.026 466.215 799.132 472.636L794.468 475.397C781.507 483.102 768.488 490.697 755.418 498.219C737.041 508.797 718.706 519.446 700.403 530.152C695.684 532.91 690.962 535.663 686.239 538.415L686.238 538.416L670.793 547.431L667.75 549.208C655.568 556.331 643.443 563.55 631.552 571.182L629.177 572.714C625.737 574.924 624.133 575.95 622.938 576.453C621.851 576.911 621.148 576.921 619.35 576.921H618.35V764.727L619.854 763.85C632.711 756.35 645.568 748.849 658.814 741.122L658.813 741.121C665.911 737.023 673.01 732.93 680.116 728.849V728.848C691.465 722.316 702.782 715.734 714.057 709.074L718.886 706.216C729.926 699.675 740.98 693.159 752.065 686.697L756.818 683.932C759.611 682.307 762.398 680.674 765.185 679.042C766.883 678.058 768.582 677.075 770.331 676.062L770.332 676.061C771.835 675.186 773.338 674.31 774.886 673.409C776.9 672.371 777.845 671.888 779.079 671.454C780.341 671.01 781.908 670.617 785.177 669.8L785.968 669.603L785.934 668.788C785.398 655.931 784.862 643.074 784.31 629.827L784.241 628.165L782.806 629.006C772.017 635.326 772.013 635.328 761.249 641.679C759.889 642.466 758.529 643.253 757.128 644.063L757.123 644.066C755.071 645.27 755.057 645.277 752.991 646.488C749.786 647.979 747.052 649.052 744.31 649.471C741.604 649.884 738.844 649.667 735.587 648.505C734.199 647.716 732.811 646.927 731.382 646.114L731.375 646.11L726.653 643.476H726.652C725.058 642.551 723.463 641.625 721.82 640.672L721.808 640.665L716.903 637.909H716.902C711.077 634.621 705.37 631.334 699.826 627.661C699.589 625.903 699.472 624.99 699.42 623.974C699.363 622.866 699.381 621.631 699.42 619.065V619.059C699.436 617.242 699.451 615.426 699.467 613.555C699.508 611.646 699.549 609.738 699.591 607.771V607.762L699.657 601.94C699.712 597.374 699.789 592.809 699.884 588.243C721.336 575.841 742.805 563.471 764.326 551.191C779.197 542.706 794.046 534.185 808.872 525.621C822.19 517.932 835.507 510.244 848.845 502.591L848.847 502.59C850.296 501.755 851.745 500.92 853.238 500.06C854.585 499.288 855.835 498.573 857.222 497.778L857.223 497.777C858.374 497.116 859.524 496.455 860.71 495.773C862.053 495.062 862.613 494.77 863.041 494.63C863.191 494.581 863.322 494.551 863.484 494.533C863.633 520.185 863.747 545.837 863.816 571.489C863.85 583.56 863.895 595.631 863.97 607.703C864.018 615.596 864.054 623.489 864.075 631.382L864.091 639.274C864.099 644.845 864.119 650.415 864.166 655.987C864.19 659.1 864.204 662.212 864.211 665.325L864.217 674.666V674.68L864.288 680.224C864.204 695.799 859.921 707.244 849.296 718.656C843.089 724.218 835.996 728.099 828.588 732.179L828.577 732.185C826.878 733.148 825.181 734.109 823.431 735.102C819.839 737.137 816.243 739.164 812.642 741.182H812.64C803.731 746.191 794.895 751.324 786.059 756.438C782.512 758.482 778.965 760.526 775.418 762.569H775.417C760.501 771.175 745.635 779.863 730.771 788.55C726.031 791.318 721.289 794.083 716.547 796.847C698.846 807.163 681.159 817.505 663.486 827.87C644.279 839.136 625.053 850.37 605.814 861.582C597.305 866.542 588.798 871.506 580.291 876.469C571.161 881.795 571.16 881.794 566.654 884.419L566.653 884.42C563.302 886.378 559.955 888.344 556.611 890.314C553.954 891.877 553.956 891.876 551.244 893.471L551.243 893.472C549.621 894.429 547.999 895.385 546.328 896.371C544.411 897.443 543.548 897.923 542.956 898.154C542.755 898.233 542.596 898.278 542.422 898.306C542.23 863.144 542.07 827.982 541.952 792.82L541.848 757.312L541.804 740.536C541.799 738.871 541.799 738.862 541.795 737.163C541.745 719.146 541.655 701.128 541.551 683.112C541.444 664.623 541.382 646.133 541.358 627.644C541.344 617.258 541.309 606.872 541.227 596.485C541.149 586.714 541.126 576.943 541.143 567.171V567.168C541.14 564.476 541.126 561.783 541.102 559.091L541.073 556.398C541.017 551.506 541.031 546.616 541.062 541.716V541.7L541.061 541.686C541.028 540.276 540.995 538.871 540.961 537.419C541.045 532.611 541.803 529.082 543.328 525.912C544.86 522.729 547.198 519.838 550.562 516.347C554.533 512.762 558.632 510.008 563.323 507.35L563.329 507.346C564.252 506.813 565.173 506.281 566.124 505.732C569.099 504.023 572.093 502.347 575.094 500.668L575.102 500.664C577.217 499.456 579.331 498.245 581.443 497.032C585.716 494.583 589.995 492.147 594.279 489.72H594.28C601.325 485.721 608.312 481.627 615.289 477.528C631.836 467.807 648.494 458.279 665.176 448.778V448.777C677.493 441.759 689.744 434.64 701.944 427.427L707.17 424.33C723.788 414.47 740.545 404.849 757.304 395.21V395.209C762.692 392.107 768.075 388.997 773.456 385.884C792.141 375.077 810.86 364.34 829.67 353.759H829.671C839.346 348.311 848.948 342.763 858.461 337.027C860.122 336.14 860.816 335.778 861.489 335.598C862.002 335.46 862.516 335.426 863.505 335.417Z",
    fill: "url(#paint9_linear_286_15)",
    stroke: "#1C14AB",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M148.28 339.996C150.1 339.79 152.026 339.96 154.812 340.279C160.094 342.606 164.971 345.558 169.986 348.581L169.996 348.587C171.495 349.467 172.995 350.348 174.539 351.255C179.256 354.031 183.956 356.835 188.658 359.643L188.663 359.646L197.187 364.668C203.019 368.102 208.845 371.549 214.667 375.003C225.559 381.459 236.488 387.852 247.412 394.245C262.864 403.289 278.281 412.387 293.672 421.535H293.673C318.362 436.198 343.24 450.523 368.168 464.76L378.854 470.856C394.579 479.836 410.213 488.978 425.845 498.133H425.846C429.222 500.105 432.603 502.07 435.986 504.03C437.757 505.057 439.527 506.084 441.352 507.142L441.353 507.143C442.974 508.08 444.596 509.017 446.267 509.983C448.16 511.121 449.052 511.659 449.682 512.112C450.208 512.492 450.544 512.809 451.174 513.436C451.313 516.971 451.349 520.515 451.343 524.065V527.571C451.342 531.408 451.329 535.244 451.316 539.083V539.085L451.31 547.05C451.306 550.549 451.301 554.049 451.294 557.549L451.27 568.049C451.253 575.187 451.245 582.326 451.237 589.464C451.22 603.078 451.193 616.692 451.16 630.306C444.821 629.041 440.022 626.865 434.122 623.573L434.12 623.572L433.379 623.162C433.374 623.16 433.372 623.158 433.367 623.155C433.365 623.154 433.363 623.153 433.361 623.152C433.359 623.151 433.357 623.149 433.355 623.148C433.354 623.147 433.346 623.144 433.345 623.143C433.34 623.14 433.338 623.138 433.333 623.136L433.286 623.11C433.26 623.096 433.219 623.073 433.193 623.059C433.17 623.045 433.124 623.021 433.101 623.008L432.915 622.904C432.9 622.896 432.837 622.861 432.821 622.853C432.798 622.84 432.798 622.84 432.775 622.827C432.771 622.825 432.733 622.803 432.729 622.801L432.682 622.775C432.671 622.769 432.647 622.755 432.636 622.749C432.602 622.73 432.622 622.742 432.589 622.724C432.569 622.712 432.562 622.709 432.542 622.697C432.498 622.673 432.493 622.67 432.448 622.646C432.404 622.621 432.47 622.657 432.426 622.633C432.387 622.612 432.44 622.641 432.402 622.62C432.378 622.607 432.38 622.607 432.355 622.594C432.349 622.59 432.316 622.572 432.309 622.568C432.303 622.565 432.303 622.565 432.297 622.562L432.285 622.556C432.283 622.555 432.281 622.553 432.279 622.552C432.277 622.551 432.275 622.55 432.273 622.549C432.251 622.536 432.284 622.554 432.262 622.542C432.24 622.53 432.236 622.528 432.215 622.517C432.213 622.515 432.193 622.504 432.191 622.503L432.18 622.497C432.178 622.496 432.176 622.494 432.174 622.493C432.172 622.492 432.17 622.491 432.168 622.49C432.117 622.462 432.125 622.467 432.074 622.438C431.998 622.396 432.103 622.454 432.027 622.412C432.013 622.404 432.018 622.407 432.004 622.399C431.975 622.383 432.009 622.402 431.98 622.386C431.942 622.365 431.924 622.355 431.886 622.334C431.833 622.305 431.844 622.311 431.792 622.282C431.787 622.28 431.774 622.271 431.769 622.269C431.764 622.266 431.75 622.259 431.745 622.256C431.734 622.249 431.709 622.236 431.697 622.229C431.641 622.199 431.707 622.234 431.65 622.203C431.642 622.198 431.635 622.195 431.627 622.19C431.625 622.189 431.623 622.188 431.621 622.187L431.609 622.181C431.607 622.18 431.605 622.178 431.603 622.177C431.557 622.151 431.555 622.15 431.509 622.125C431.377 622.052 431.45 622.093 431.318 622.02C431.302 622.01 431.24 621.976 431.224 621.967C431.213 621.961 431.139 621.92 431.128 621.914H431.129C427.982 620.166 424.843 618.403 421.702 616.638L421.698 616.636L415.499 613.192H415.5C397.448 603.152 388.443 598.143 383.563 595.259C381.123 593.817 379.746 592.924 378.796 592.213C377.981 591.603 377.472 591.119 376.849 590.499C376.74 586.541 376.711 582.622 376.758 578.662V578.656L376.78 575.159C376.799 572.303 376.828 569.445 376.859 566.587L376.868 565.739L376.033 565.592C375.191 565.443 374.348 565.294 373.481 565.141C368.502 563.642 364.47 561.215 359.825 558.509L359.823 558.508L356.832 556.772H356.833C353.599 554.892 350.372 553 347.146 551.104L347.144 551.103C345.505 550.143 345.504 550.143 343.832 549.163C336.911 545.109 330 541.038 323.092 536.96V536.959L312.515 530.741C298.496 522.516 284.534 514.2 270.602 505.829L264.632 502.238L255.664 496.853C246.69 491.477 237.697 486.134 228.676 480.835C227.416 480.094 226.156 479.354 224.857 478.591C221.789 476.787 218.72 474.984 215.651 473.182L214.211 472.336L214.146 474.005C213.231 497.321 212.549 520.635 212.127 543.966C211.924 554.796 211.65 565.608 211.207 576.426C210.781 586.902 210.549 597.365 210.448 607.845C210.377 611.809 210.238 615.772 210.027 619.73C209.506 628.967 209.235 633.702 209.762 638.315C210.289 642.93 211.612 647.409 214.186 656.145L214.256 656.381L214.427 656.558C223.973 666.411 236.373 671.832 248.546 677.136C257.059 681.046 264.98 685.933 273.07 690.81L273.082 690.816C276.324 692.713 279.569 694.604 282.816 696.491V696.492C289.334 700.294 295.849 704.103 302.359 707.918C316.851 716.403 331.375 724.828 345.973 733.132L352.234 736.684C353.81 737.575 355.386 738.467 357.01 739.386H357.011C363.088 742.811 369.151 746.159 375.412 749.289L376.859 750.013V730.52C389.69 736.834 402.104 743.572 414.411 750.878L414.413 750.879L424.212 756.663C426.331 757.92 426.332 757.921 428.496 759.204L428.503 759.208L428.509 759.211C435.995 763.506 443.599 767.596 451.158 771.716V888.401C445.542 887.248 442.444 886.348 437.457 883.621L437.455 883.62L433.338 881.379H433.337C431.873 880.565 430.41 879.751 428.902 878.912L428.898 878.91C426.561 877.623 426.561 877.623 424.176 876.31H424.175C409.874 868.369 395.803 860.042 381.745 851.649C369.256 844.194 356.705 836.855 344.093 829.609H344.094C314.28 812.467 284.581 795.132 255.132 777.378L251.313 775.086C232.209 763.649 212.918 752.528 193.661 741.378H193.662C191.924 740.369 190.185 739.361 188.394 738.321C185.09 736.404 181.785 734.491 178.477 732.582C160.514 722.151 151.699 717.024 146.308 711.894C141.012 706.854 139.03 701.821 134.945 691.309C134.128 686.622 134.103 682.053 134.162 677.201L134.163 677.191V677.182L134.136 672.968C134.114 668.344 134.138 663.721 134.162 659.091V659.083L134.136 649.088C134.124 644.577 134.123 640.065 134.128 635.554L134.157 622.018C134.18 612.567 134.17 603.116 134.164 593.668C134.16 577.808 134.181 561.947 134.219 546.086C134.262 527.743 134.265 509.401 134.246 491.059C134.229 473.412 134.239 455.765 134.262 438.118C134.271 430.607 134.27 423.096 134.263 415.585C134.255 406.749 134.272 397.912 134.307 389.075V389.074C134.316 385.827 134.317 382.58 134.309 379.333C134.299 374.912 134.319 370.491 134.347 366.066V366.052C134.337 364.77 134.327 363.489 134.317 362.169C134.369 357.654 134.869 354.168 136.106 351.044C137.328 347.959 139.297 345.156 142.395 342.041C144.753 340.773 146.493 340.199 148.28 339.996Z",
    fill: "url(#paint10_linear_286_15)",
    stroke: "#1C14AB",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2023.85 508V167H2286.57C2298.62 167 2309.57 170 2319.41 175.999C2329.56 181.998 2337.65 190.049 2343.68 200.153C2349.71 209.941 2352.72 220.834 2352.72 232.832V299.611C2352.72 303.716 2352.4 307.662 2351.77 311.451C2351.14 315.24 2350.02 318.871 2348.44 322.344C2353.83 329.606 2358.12 337.184 2361.29 345.078C2364.78 352.971 2366.52 360.865 2366.52 368.758V442.168C2366.52 454.166 2363.51 465.217 2357.48 475.32C2351.45 485.108 2343.36 493.002 2333.21 499.001C2323.05 505 2311.95 508 2299.89 508H2023.85ZM2092.38 445.009H2297.04C2298.62 445.009 2300.05 444.536 2301.32 443.589C2302.59 442.326 2303.22 440.905 2303.22 439.326V371.6C2303.22 370.021 2302.59 368.758 2301.32 367.811C2300.05 366.548 2298.62 365.916 2297.04 365.916H2092.38C2090.8 365.916 2089.37 366.548 2088.1 367.811C2087.15 368.758 2086.67 370.021 2086.67 371.6V439.326C2086.67 440.905 2087.15 442.326 2088.1 443.589C2089.37 444.536 2090.8 445.009 2092.38 445.009ZM2092.38 302.926H2283.71C2285.3 302.926 2286.57 302.453 2287.52 301.505C2288.47 300.242 2288.95 298.822 2288.95 297.243V235.674C2288.95 234.095 2288.47 232.832 2287.52 231.885C2286.57 230.622 2285.3 229.99 2283.71 229.99H2092.38C2090.8 229.99 2089.37 230.622 2088.1 231.885C2087.15 232.832 2086.67 234.095 2086.67 235.674V297.243C2086.67 298.822 2087.15 300.242 2088.1 301.505C2089.37 302.453 2090.8 302.926 2092.38 302.926Z",
    fill: "url(#paint11_linear_286_15)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1627.6 508C1615.54 508 1604.43 505 1594.28 499.001C1584.44 493.002 1576.51 485.108 1570.48 475.32C1564.45 465.217 1561.44 454.166 1561.44 442.168V167H1624.26V439.326C1624.26 440.905 1624.74 442.326 1625.69 443.589C1626.96 444.536 1628.39 445.009 1629.98 445.009H1834.63C1836.22 445.009 1837.64 444.536 1838.91 443.589C1840.18 442.326 1840.82 440.905 1840.82 439.326V167H1904.12V442.168C1904.12 454.166 1901.1 465.217 1895.07 475.32C1889.05 485.108 1880.96 493.002 1870.8 499.001C1860.97 505 1850.02 508 1837.96 508H1627.6Z",
    fill: "url(#paint12_linear_286_15)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1166.16 508C1154.1 508 1142.99 505 1132.84 499.001C1123 493.002 1115.07 485.108 1109.04 475.32C1103.01 465.217 1100 454.166 1100 442.168V232.832C1100 220.834 1103.01 209.941 1109.04 200.153C1115.07 190.049 1123 181.998 1132.84 175.999C1142.99 170 1154.1 167 1166.16 167H1441.73V229.99H1179.48C1174.41 229.99 1170.28 231.411 1167.11 234.253C1164.25 237.094 1162.82 241.199 1162.82 246.567V428.433C1162.82 433.485 1164.25 437.589 1167.11 440.747C1170.28 443.589 1174.41 445.009 1179.48 445.009H1441.73V508H1166.16Z",
    fill: "url(#paint13_linear_286_15)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M2486.26 167H2800.53V230.703H2486.26V167Z",
    fill: "url(#paint14_linear_286_15)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M2486.26 305.647H2800.53V369.351H2486.26V305.647Z",
    fill: "url(#paint15_linear_286_15)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M2486.26 444.295H2800.53V507.998H2486.26V444.295Z",
    fill: "url(#paint16_linear_286_15)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1138.37 834C1131.72 834 1125.62 832.358 1120.05 829.075C1114.48 825.792 1110.08 821.323 1106.85 815.668C1103.62 810.013 1102 803.812 1102 797.063V673.937C1102 667.188 1103.62 660.987 1106.85 655.332C1110.08 649.677 1114.48 645.208 1120.05 641.925C1125.62 638.642 1131.72 637 1138.37 637H1259.6C1266.24 637 1272.26 638.642 1277.65 641.925C1283.22 645.208 1287.62 649.677 1290.85 655.332C1294.26 660.987 1295.97 667.188 1295.97 673.937V687.344H1263.37V675.032C1263.37 673.573 1262.83 672.387 1261.75 671.475C1260.86 670.563 1259.78 670.107 1258.52 670.107H1139.18C1137.92 670.107 1136.75 670.563 1135.68 671.475C1134.78 672.387 1134.33 673.573 1134.33 675.032V795.968C1134.33 797.427 1134.78 798.613 1135.68 799.525C1136.75 800.437 1137.92 800.893 1139.18 800.893H1258.52C1259.78 800.893 1260.86 800.437 1261.75 799.525C1262.83 798.613 1263.37 797.427 1263.37 795.968V757.389H1218.65V724.282H1295.97V797.063C1295.97 803.812 1294.26 810.013 1290.85 815.668C1287.62 821.323 1283.22 825.792 1277.65 829.075C1272.26 832.358 1266.24 834 1259.6 834H1138.37Z",
    fill: "url(#paint17_linear_286_15)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1475.68 834V673.937C1475.68 667.188 1477.3 660.987 1480.53 655.332C1483.76 649.677 1488.16 645.208 1493.73 641.925C1499.3 638.642 1505.4 637 1512.05 637H1633.28C1639.92 637 1645.94 638.642 1651.33 641.925C1656.9 645.208 1661.3 649.677 1664.53 655.332C1667.94 660.987 1669.65 667.188 1669.65 673.937V834H1637.05V766.418H1508.01V834H1475.68ZM1508.01 733.585H1637.05V675.032C1637.05 673.573 1636.51 672.387 1635.43 671.475C1634.54 670.563 1633.46 670.107 1632.2 670.107H1512.86C1511.6 670.107 1510.43 670.563 1509.35 671.475C1508.46 672.387 1508.01 673.573 1508.01 675.032V733.585Z",
    fill: "url(#paint18_linear_286_15)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1849.86 834V637H1886.77L1959.51 725.103L2031.97 637H2069.15V834H2036.55V682.967L1959.51 776.268L1882.19 683.24V834H1849.86Z",
    fill: "url(#paint19_linear_286_15)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2249.85 834V637H2427.92V670.107H2282.45V719.083H2399.63V751.917H2282.45V800.893H2427.92V834H2249.85Z",
    fill: "url(#paint20_linear_286_15)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2640.38 834C2633.73 834 2627.63 832.358 2622.06 829.075C2616.67 825.792 2612.36 821.323 2609.13 815.668C2605.89 810.013 2604.28 803.812 2604.28 797.063V783.929H2636.61V795.968C2636.61 797.427 2637.06 798.613 2637.95 799.525C2638.85 800.437 2640.02 800.893 2641.46 800.893H2760.53C2761.97 800.893 2763.13 800.437 2764.03 799.525C2765.11 798.613 2765.65 797.427 2765.65 795.968V756.842C2765.65 755.565 2765.11 754.47 2764.03 753.558C2763.13 752.464 2761.97 751.917 2760.53 751.917H2640.38C2633.73 751.917 2627.63 750.275 2622.06 746.992C2616.67 743.708 2612.36 739.331 2609.13 733.858C2605.89 728.204 2604.28 722.002 2604.28 715.253V673.937C2604.28 667.188 2605.89 660.987 2609.13 655.332C2612.36 649.677 2616.67 645.208 2622.06 641.925C2627.63 638.642 2633.73 637 2640.38 637H2761.88C2768.52 637 2774.54 638.642 2779.93 641.925C2785.5 645.208 2789.9 649.677 2793.13 655.332C2796.54 660.987 2798.25 667.188 2798.25 673.937V687.071H2765.65V675.032C2765.65 673.573 2765.11 672.387 2764.03 671.475C2763.13 670.563 2761.97 670.107 2760.53 670.107H2641.46C2640.02 670.107 2638.85 670.563 2637.95 671.475C2637.06 672.387 2636.61 673.573 2636.61 675.032V714.158C2636.61 715.435 2637.06 716.621 2637.95 717.715C2638.85 718.627 2640.02 719.083 2641.46 719.083H2761.88C2768.52 719.083 2774.54 720.725 2779.93 724.008C2785.5 727.292 2789.9 731.761 2793.13 737.415C2796.54 742.888 2798.25 748.998 2798.25 755.747V797.063C2798.25 803.812 2796.54 810.013 2793.13 815.668C2789.9 821.323 2785.5 825.792 2779.93 829.075C2774.54 832.358 2768.52 834 2761.88 834H2640.38Z",
    fill: "url(#paint21_linear_286_15)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_286_15",
    x1: 500,
    y1: 0,
    x2: 500,
    y2: 479.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#191919"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_286_15",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1292.22 55) rotate(147.973) scale(934.447)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_286_15",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-93.3334 -122.222) rotate(50.3656) scale(714.164)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_286_15",
    x1: 500,
    y1: 0,
    x2: 500,
    y2: 1000,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#030028"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C1A33"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_286_15",
    x1: 493.509,
    y1: 228.906,
    x2: 493.509,
    y2: 295.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_286_15",
    x1: 274.349,
    y1: 228.906,
    x2: 274.349,
    y2: 295.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_286_15",
    x1: 722.396,
    y1: 228.906,
    x2: 722.396,
    y2: 295.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_286_15",
    x1: 493.509,
    y1: 360.391,
    x2: 493.509,
    y2: 426.949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_286_15",
    x1: 493.509,
    y1: 100.664,
    x2: 493.509,
    y2: 167.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_286_15",
    x1: 703.124,
    y1: 334.414,
    x2: 703.124,
    y2: 899.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_286_15",
    x1: 292.734,
    y1: 338.906,
    x2: 292.734,
    y2: 889.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD00FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_286_15",
    x1: 2800.53,
    y1: 337.5,
    x2: 1100,
    y2: 337.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_286_15",
    x1: 2800.53,
    y1: 337.5,
    x2: 1100,
    y2: 337.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_286_15",
    x1: 2800.53,
    y1: 337.5,
    x2: 1100,
    y2: 337.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_286_15",
    x1: 2800.53,
    y1: 337.5,
    x2: 1100,
    y2: 337.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_286_15",
    x1: 2800.53,
    y1: 337.5,
    x2: 1100,
    y2: 337.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_286_15",
    x1: 2800.53,
    y1: 337.5,
    x2: 1100,
    y2: 337.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_286_15",
    x1: 1950.12,
    y1: 598.457,
    x2: 1941.86,
    y2: 1039.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3879,
    stopColor: "#BEC4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7091,
    stopColor: "#7A8594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697486"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_286_15",
    x1: 1950.12,
    y1: 598.457,
    x2: 1941.86,
    y2: 1039.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3879,
    stopColor: "#BEC4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7091,
    stopColor: "#7A8594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697486"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_286_15",
    x1: 1950.12,
    y1: 598.457,
    x2: 1941.86,
    y2: 1039.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3879,
    stopColor: "#BEC4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7091,
    stopColor: "#7A8594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697486"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_286_15",
    x1: 1950.12,
    y1: 598.457,
    x2: 1941.86,
    y2: 1039.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3879,
    stopColor: "#BEC4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7091,
    stopColor: "#7A8594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697486"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_286_15",
    x1: 1950.12,
    y1: 598.457,
    x2: 1941.86,
    y2: 1039.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3879,
    stopColor: "#BEC4CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7091,
    stopColor: "#7A8594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#697486"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHeader);
export default __webpack_public_path__ + "static/media/logo-header.a9a70069e59f13f38345a6c35028d2ce.svg";
export { ForwardRef as ReactComponent };